// Validation for Project PO miscellaneous charge rows.
// A row is invalid ONLY when it has an amount but no description. A description with
// no amount (0 or empty) is allowed and saves as before. A fully-empty row is ignored.
// Save is blocked while any row is invalid, so every saved amount is always visible
// in the live summary.
export const miscRowError = (m) => {
  const hasDesc = !!(m && m.description && String(m.description).trim());
  const amt = parseFloat(m && m.amount) || 0;
  if (amt > 0 && !hasDesc) return 'Enter a description for this amount.';
  return '';
};

export const hasMiscErrors = (rows) => (rows || []).some((m) => miscRowError(m));
